<script>
//Headline.vue
//used für blade-templates

export default {
    props: {
        headline: String,
        className: String,
    },
}
</script>

<template>
    <span :class="className">{{ headline }}</span>
</template>


